export function getBrowser(): string {
  if (typeof window === 'undefined') {
    // On the server
    return 'server';
  }

  const userAgent = window.navigator.userAgent;

  if (userAgent.includes('Chrome')) {
    return 'chrome';
  }
  if (userAgent.includes('Firefox')) {
    return 'firefox';
  }
  if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
    return 'safari';
  }
  if (userAgent.includes('Edg')) {
    return 'edge';
  }
  if (userAgent.includes('OPR') || userAgent.includes('Opera')) {
    return 'opera';
  }

  return 'unknown';
}
